<template>
  <Teleport to="body">
    <div
      v-if="open"
      class="contrat-popup"
      role="dialog"
      aria-modal="true"
      aria-labelledby="contrat-popup-title"
    >
      <div class="contrat-popup__backdrop" @click="close" />
      <div class="contrat-popup__panel">
        <button
          v-if="!required"
          type="button"
          class="contrat-popup__close"
          aria-label="Fermer"
          @click="close"
        >
          ×
        </button>

        <p class="contrat-popup__eyebrow">Contrat de souscription</p>

        <div class="contrat-popup__scroll">
          <!-- <p class="contrat-popup__text">
            Le présent contrat de souscription formalise l’engagement entre le Client et
            patrimonea by Gwem (ci-après « PBG »), 
          </p> -->

          <!-- <div class="contrat-popup__more-actions">
            <button type="button" class="contrat-popup__more" @click="expanded = !expanded">
              {{ expanded ? 'Réduire' : 'En savoir plus' }}
            </button>
            <a
              v-if="officialUrl"
              :href="officialUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="contrat-popup__official"
            >
              Document (PDF)
            </a>
          </div> -->

          <!-- <div v-if="expanded" class="contrat-popup__extra">
            <p>SAS au capital de 10 000 000 FCFA, filiale du
            Groupe GABRIEL WEALTH MANAGEMENT, siège social Abidjan Plateau, Avenue Dr Crozet,
            6ᵉ étage, immeuble XL, RCCM CI-ABJ-03-2026-B16-00048, représentée par Madame Orphée
            MONNET KEBE, Présidente.</p>
            <h3>Article 1 — Objet</h3>
            <p>
              Le contrat a pour objet la fourniture d’un diagnostic patrimonial, d’un plan
              d’action personnalisé et d’un suivi via l’application PATRIMONEA, selon la formule
              souscrite (Accès, Persona, Duo ou Pro — basique ou prémium).
            </p>
            <h3>Article 2 — Prestations</h3>
            <ul>
              <li>Collecte et consolidation des informations patrimoniales du Client ;</li>
              <li>Analyse et recommandations formulées par PBG ;</li>
              <li>Accès au tableau de bord et aux livrables prévus par l’offre ;</li>
              <li>Échanges avec un conseiller selon le volume d’appels de la formule.</li>
            </ul>
            <h3>Article 3 — Engagements du Client</h3>
            <ul>
              <li>Fournir des informations exactes et à jour ;</li>
              <li>Déposer les justificatifs demandés dans les délais ;</li>
              <li>Régler le prix de la formule selon la modalité choisie ;</li>
              <li>Utiliser l’application conformément à sa destination.</li>
            </ul>
            <h3>Article 4 — Prix et paiement</h3>
            <p>
              Le prix est celui affiché lors de la souscription (paiement total ou échelonné).
              Le règlement conditionne l’activation complète des prestations post-paiement.
            </p>
            <h3>Article 5 — Nature des conseils</h3>
            <p>
              Les recommandations sont fournies à titre informatif et patrimonial. Elles ne
              constituent ni un ordre d’investissement, ni une garantie de performance, ni une
              gestion discrétionnaire.
            </p>
            <h3>Article 6 — Durée</h3>
            <p>
              Sauf mention contraire, l’accompagnement couvre douze mois à compter de la
              validation du paiement.
            </p>
            <h3>Article 7 — Confidentialité</h3>
            <p>
              PBG s’engage à protéger les données patrimoniales du Client. Le traitement des
              données personnelles est précisé dans la politique de confidentialité.
            </p>
            <h3>Article 8 — Droit applicable</h3>
            <p>
              Le présent contrat est soumis au droit ivoirien. Tout litige sera tranché
              définitivement par la Cour d’Arbitrage de Côte d’Ivoire (CACI).
            </p>
            <p class="contrat-popup__text">
            En signant, le Client souscrit à l’offre d’analyse patrimoniale et d’accompagnement
            choisie, et accepte les obligations réciproques ci-dessous.
          </p>
          </div> -->

          <div class="contrat-popup__sign">
            <!-- Signature tracée remplacée par une case à cocher de type "checkout" (cohérent
                 avec PopCGU) : la preuve de consentement reste le Signature enregistré côté
                 backend (PDF tamponné + horodatage), pas le tracé manuscrit. Conservé en
                 commentaire au cas où :
            <SignatureTact
              document-name="Contrat de souscription"
              :locked="false"
              :busy="busy"
              @signature-saved="onSignatureSaved"
            />
            -->
            <CheckAcceptance
              document-name="Contrat de souscription"
              :locked="false"
              :busy="busy"
              @signature-saved="onSignatureSaved"
            >
              J’adhère aux termes du
              <a v-if="officialUrl" :href="officialUrl" target="_blank" rel="noopener noreferrer">contrat de souscription</a>
              <a v-else href="#" @click.prevent="expanded = true">contrat de souscription</a>.
            </CheckAcceptance>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
// import SignatureTact from '@/components/shared/SignatureTact.vue'; // remplacé par CheckAcceptance
import CheckAcceptance from '@/components/shared/CheckAcceptance.vue';
import { resolveBackendUrl } from '@/utils/apiOrigin';

// Le stockage Azure (patrimoneadevdocs) reste privé : ce lien passe uniquement par
// notre propre domaine (/api/templates/preview-public/), jamais par l'URL blob brute,
// pour ne pas exposer l'infrastructure de stockage aux utilisateurs.
const DEFAULT_CONTRAT_URL = resolveBackendUrl(
  '/api/templates/preview-public/?titre=' + encodeURIComponent('Contrat de souscription'),
);

export default {
  name: 'PopContratSouscription',
  components: { CheckAcceptance },
  props: {
    open: { type: Boolean, default: false },
    officialUrl: { type: String, default: DEFAULT_CONTRAT_URL },
    busy: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    documentTitre: {
      type: String,
      default: 'Contrat de souscription',
    },
  },
  emits: ['close', 'accepted'],
  data() {
    return { expanded: false };
  },
  watch: {
    open(isOpen) {
      if (typeof document === 'undefined') return;
      document.body.style.overflow = isOpen ? 'hidden' : '';
      if (isOpen) this.expanded = false;
    },
  },
  beforeUnmount() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
  },
  methods: {
    close() {
      if (this.required) return;
      this.$emit('close');
    },
    onSignatureSaved(payload) {
      this.$emit('accepted', {
        ...payload,
        documentTitre: this.documentTitre,
        kind: 'souscription',
        expanded: this.expanded,
        ts: Date.now(),
      });
    },
  },
};
</script>

<style scoped>
.contrat-popup {
  position: fixed;
  inset: 0;
  z-index: 11050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.contrat-popup__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.58);
  backdrop-filter: blur(4px);
}

.contrat-popup__panel {
  position: relative;
  z-index: 1;
  width: min(640px, 100%);
  max-height: min(92dvh, 92vh);
  display: flex;
  flex-direction: column;
  padding: 1.35rem 1.35rem 1.1rem;
  border-radius: 20px;
  background:
    radial-gradient(circle at top right, rgba(216, 156, 36, 0.12), transparent 38%),
    #fff;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.24);
}

.contrat-popup__close {
  position: absolute;
  top: 0.8rem;
  right: 0.9rem;
  width: 2.25rem;
  height: 2.25rem;
  border: 0;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.06);
  color: #0f172a;
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
}

.contrat-popup__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--brand-brown, #8a6a1a);
}

.contrat-popup__title {
  margin: 0 0 0.85rem;
  padding-right: 2rem;
  font-size: 1.35rem;
  line-height: 1.25;
  color: var(--brand-navy, #01263e);
}

.contrat-popup__scroll {
  overflow: auto;
  min-height: 0;
  padding-right: 0.15rem;
}

.contrat-popup__text {
  margin: 0 0 0.85rem;
  color: var(--brand-navy, #01263e);
  line-height: 1.6;
  font-size: 0.95rem;
}

.contrat-popup__more-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
  margin: 0 0 1rem;
}

.contrat-popup__more,
.contrat-popup__official {
  border: 0;
  background: transparent;
  color: var(--brand-navy, #01263e);
  font-weight: 700;
  font-size: 0.92rem;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
}

.contrat-popup__extra {
  margin: 0 0 1.15rem;
  padding: 0.9rem 1rem;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid rgba(1, 38, 62, 0.08);
}

.contrat-popup__extra h3 {
  margin: 0.75rem 0 0.35rem;
  font-size: 0.95rem;
  color: var(--brand-navy, #01263e);
}

.contrat-popup__extra h3:first-child {
  margin-top: 0;
}

.contrat-popup__extra p,
.contrat-popup__extra ul {
  margin: 0 0 0.55rem;
  padding-left: 0;
  font-size: 0.9rem;
  line-height: 1.55;
  color: var(--brand-navy, #01263e);
}

.contrat-popup__extra ul {
  padding-left: 1.15rem;
}

.contrat-popup__sign {
  margin-top: 0.25rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(1, 38, 62, 0.1);
}
</style>
